import { Component, inject } from '@angular/core';
import { ProvisionGroup } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { ProvisionGroupService } from '../services/provision-group.service';

@Component({
  selector: 'app-provision-group-dropdown',
  template: '',
  providers: [ProvisionGroupService],
  standalone: true
})
export class ProvisionGroupDropdownComponent extends GenericBaseModelDropDown<ProvisionGroup> {

  constructor() {
    super(inject(ProvisionGroupService), "ProvisionGroup");
  }

}
